/**
 * Geometria do logo Alert AI (folha azul + anel azul-marinho + pupila branca),
 * em coordenadas normalizadas (centro da folha = 0,0; y para cima; ~[-1, 1]).
 * Compartilhada pela cena 3D (three.js) e pela versão SVG de reserva, para as duas
 * ficarem idênticas em forma e cor.
 */

export type LogoCmd = readonly [op: "M" | "L" | "C" | "Z", ...n: number[]];

/** Folha: duas pontas (topo-esquerda e base-direita) e dois cantos bem arredondados. */
export const LEAF: readonly LogoCmd[] = [
  ["M", -0.96, 0.95],
  ["L", -0.45, 1.0],
  ["C", 0.35, 1.0, 1.0, 0.35, 1.0, -0.3],
  ["L", 0.96, -0.95],
  ["L", 0.45, -1.0],
  ["C", -0.35, -1.0, -1.0, -0.35, -1.0, 0.3],
  ["Z"],
];

/** Anel escuro (ao redor da pupila), medido sobre o logo oficial. */
export const RING = { cx: 0.264, cy: 0.262, outer: 0.755, inner: 0.486, pupil: 0.272 } as const;

export const LOGO_COLORS = { leaf: "#0a7ee6", ring: "#151c8f", pupil: "#ffffff" } as const;

/** Caminho SVG da folha (o eixo y do SVG é invertido). */
export function leafSvgPath(): string {
  return LEAF.map(([op, ...n]) => {
    if (op === "Z") return "Z";
    const p = n.map((v, i) => (i % 2 === 1 ? -v : v));
    return `${op}${p.join(" ")}`;
  }).join(" ");
}
